import React, {useState, useEffect} from 'react'
import '../components/styles/Home.css'
import asset1 from '../assets/asset2.png'
import PawTrail from '../components/PawTrail'
import touchGrassSign from "../assets/touch.png"; 
import bg from '../assets/bg.png';
import bgMobile from '../assets/bg-mobile.png';
import titleImg from '../assets/title.png';
import dogImg from '../assets/hero.png';
import astro from '../assets/astro.png';
import family from '../assets/family.png';
import karate from '../assets/karate.png';
import jump from '../assets/jump.png';
import team1 from '../assets/team1.png';
import team2 from '../assets/team2.png';
import { FaYoutube } from 'react-icons/fa';
import WobblyTitle from "../components/WobblyTitle";
import {
    FaTelegram,
    FaInstagram,
    FaTiktok,
    FaChartLine
} from 'react-icons/fa'
import Navbar from '../components/Navbar'
import Step from '../components/Step'

import GrassField from '../components/GrassField'; 
import ScrambledTextBlock from '../components/ScrambleTextBlock'
import { FaXTwitter } from 'react-icons/fa6'
import dex from '../assets/dex.webp'; 
import AudioPlayer from "../components/AudioPlayer";

export default function Home() {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [scrollX, setScrollX] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const scrollPercent = scrollTop / docHeight;
      setScrollX(scrollPercent);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);




  return (
    <div className='home'>
         <AudioPlayer />
       <section className="hero">
        <Navbar />

        <picture className="hero-bg-wrap">
          <source media="(max-width: 600px)" srcSet={bgMobile} />
          <img src={bg} alt="" className="hero-bg" />
        </picture>

        <img src={titleImg} alt="GOD THE DOG" className="hero-title" />
        <img src={dogImg} alt="Dog" className="hero-dog" />
      </section>



      <section className="section about">
        <img
        src={family}
        alt="God Dog Family"
        className="family"
      />
        <WobblyTitle text="LORE" className="about-title" />
            <p>
            From birth, God was mocked for being different from his siblings. He was small, clumsy and struggled with his words. The simplest things were challenges for him, yet even when it got him down, he always bounced back.
            <br></br><br></br>Though he didn’t know it yet, God’s sheer grit and unique way of looking at the world became his biggest strength, a superpower that didn’t detract from his way of life, but instead enhanced it.  
            <br></br><br></br>God was destined for great things. He was a special dog. All because he was the pup that never gave up.  
          </p>


      </section>
      <section className="section mission">
        <img
           src={asset1}
           alt="Skating God Dog"
            className="skater-dog"
             style={{
             transform: `translateX(-${scrollX * 200}vw)`
             }}
         />
        <div className='mission-content'>

                <img
                  src={karate}
                  alt="karate God Dog"
                  className="karate"
                />
                  <WobblyTitle text="MISSION" className="about-title" />
                    <p>
                      God's mission is to inspire self confidence and resilience through the story of God —a unique pup who defies society’s expectations, embraces his differences and never gives up despite endless challenges. 
                      <br></br><br></br>Through emotive art and motivational messaging, we celebrate those of any age, color or species who go against the grain, reminding them that their differences are their greatest strengths and that they are never alone on their journey.
                    </p>
        </div>
        
      </section>

    

      <section className="how-to-buy section">
                   <img
                      src={astro}
                      alt="Astronaut God Dog"
                      className="astro"
                      style={{
                        transform: `translateX(${scrollX * 200}vw)`
                      }}
                    />

              <div className='how-to-buy-content'>
                  <img
                  src={jump}
                  alt="God Dog"
                  className="jump"
                />
                  <WobblyTitle text="HOW TO BUY" className="about-title" />
                  <Step text={
                    <>
                      1. Go to <a href="https://portal.abs.xyz/login" target="_blank" rel="noopener noreferrer">https://portal.abs.xyz/login</a> to create your account or login.
                    </>
                  } />
                  <Step text="2. Fund your account by going to ‘My Wallet’, clicking ‘Fund’, and choosing your preferred payment or bridging option. " />
                  <Step text="3. Click ‘Trade’ on the sidebar on the left hand side." />
                  <Step text={
                    <>
                      4. Enter the contract address, look for the blue verification tick next to $god, and initiate the swap.
                      <p className="contract-address">
                        0x3D72DDD35cadb4e5B22CDB20b36f98077BE84284
                      </p>
                    </>
                  } />
                  <div className="watch-wrap">
                    <a
                      className="watch-video-btn"
                      href="https://www.youtube.com/watch?v=9MtS-vDeEXw"  
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Watch how to buy on YouTube"
                    >
                      <FaYoutube className="yt-icon" />
                      Watch the walkthrough
                    </a>
                  </div>
        </div>
        

      </section>
      <section className="team section">
         <WobblyTitle text="TEAM" className="about-title" />

        <div className="team-grid">

          <div className="team-card">
            <div className="pfp-wrap color-b">
              <img src={team2} alt="artist" className="pfp" />
            </div>
            <div className="team-meta">
               <div className="team-name">Nish</div>
              <a className="team-handle" href="https://x.com/nishseq" target="_blank" rel="noopener noreferrer">@nishseq</a>
            </div>
          </div>
          <div className="team-card">
            <div className="pfp-wrap color-a">
              <img src={team1} alt="Mitch" className="pfp" />
            </div>
            <div className="team-meta">
              <div className="team-name">Mitch</div>
              <a className="team-handle" href="https://x.com/Mitchv_eth" target="_blank" rel="noopener noreferrer">@Mitchv_eth</a>
            </div>
          </div>
        </div>
      </section>

      <section className="socials section">
        <div className='social-icons'>
            <a href="https://x.com/godthedogabs" target="_blank" rel="noopener noreferrer">
              <FaXTwitter />
            </a>
            <a href="https://t.me/godthedog" target="_blank" rel="noopener noreferrer">
              <FaTelegram />
            </a>
            <a href="https://www.instagram.com/godthedogofficial/" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
             <a href="https://www.tiktok.com/@godthedogofficial" target="_blank" rel="noopener noreferrer">
              <FaTiktok />
            </a>
             <a href="https://dexscreener.com/abstract/0x21261d743f28da76c15f1234d7c1a1bf9165304b" target="_blank" rel="noopener noreferrer">
              <img src={dex} alt="Dexscreener" className="dex-icon" />
            </a>

        </div>
      </section>
      <img
        src={touchGrassSign}
        alt="Touch Grass Sign"
        className="touch-grass-sign"
      />
      <GrassField />
    </div>
  )
}
